// sensei-app/client/widgets/EnrollmentStatsWidget.widget.js
export default {
    name: "EnrollmentStatsWidget",
    type: "MultiDisplayWidget",
    description: "Shows key stats for courses managed by the admin.",
    roles: ["courseAdmin"], // This widget is for Course Administrators
    widget: {
        title: "Course Vitals",
        size: "medium",
        
        dataProvider: {
            main: { // MultiDisplayWidget expects the 'main' data source
                rpc: "CAdminCourseRpc.getDashboardStats"
                // The RPC returns a single object like { totalCourses: 5, ... }, so no transform is needed.
            }
        },

        // 'items' config tells MultiDisplayWidget how to render the data
        items: [
            { label: "Total Courses", valueField: "totalCourses", icon: "bi bi-journals" },
            { label: "Total Enrollments", valueField: "totalEnrollments", icon: "bi bi-people-fill" },
            { label: "Avg. Pass Rate", valueField: "avgPassRate", format: "percentage", icon: "bi bi-patch-check-fill" }
        ]
    }
};